// Generated by CoffeeScript 1.12.7
require.config({
  baseUrl: '/javascript/libs',
  enforceDefine: false,
  waitSeconds: 120,
  paths: {
    root: '..',
    collections: '../collections',
    etc: '../etc',
    models: '../models',
    views: '../views',
    templates: '../../templates',
    underscore: 'lodash',
    cloudinary: 'cloudinary/cloudinary-core-shrinkwrap',
    text: 'require_plugins/text',
    propertyParser: 'require_plugins/propertyParser'
  }
});

define('../main',['require','jquery','raven','root/app','polyfills/object-entries'],function(require) {
  var $, App, Raven;
  window.DEBUG = false;
  $ = require('jquery');
  Raven = require('raven');
  App = require('root/app');
  require('polyfills/object-entries');
  Raven.config(GLOBALS.publicKeys.sentry, {
    environment: GLOBALS.env,
    release: GLOBALS.version,
    logger: 'javascript'
  }).install();
  return $(document).ready(function() {
    var app;
    return app = new App(GLOBALS.surveyId);
  });
});

